module.exports = __webpack_public_path__ + "img/40_43.6573633d.png";